import userAPI from "@/api/user";

const getUsers = async (context, data) => {
  const response = await userAPI.getUsers(data.token, data.page, data.email);
  if (response.status) {
    context.commit("setUsers", response.data);
  }
};

const getUserWithoutPagination = async (context, data) => {
  const response = await userAPI.getUserWithoutPagination(
    data.token,
    data.vet,
    data.owner
  );
  if (response.status) {
    if (data.vet) {
      context.commit("setVetsWithoutPagination", response.data);
    }

    if (data.owner) {
      context.commit("setOwnersWithoutPagination", response.data);
    }
  }
};

let actions = {
  getUsers,
  getUserWithoutPagination
};

export default actions;
